import { useCallback, useMemo, useState } from 'react';

import DismissButton from '../DismissButton';

import { AuthStep } from './constants';
import OnboardingAuthForgot from './OnboardingAuthForgot';
import OnboardingAuthLogin from './OnboardingAuthLogin';
import OnboardingAuthSignup from './OnboardingAuthSignup';

interface Props {
  hideAuth: () => void;
}

const OnboardingAuth = ({ hideAuth }: Props) => {
  const [step, setStep] = useState<AuthStep>(AuthStep.Login);

  const onForgot = useCallback(() => {
    setStep(AuthStep.Forgot);
  }, []);

  const onLogin = useCallback(() => {
    setStep(AuthStep.Login);
  }, []);

  const onSignup = useCallback(() => {
    setStep(AuthStep.Signup);
  }, []);

  const authStep = useMemo(() => {
    switch (step) {
      case AuthStep.Login:
        return (
          <OnboardingAuthLogin
            onSuccess={hideAuth}
            onForgot={onForgot}
            onSignup={onSignup}
          />
        );
      case AuthStep.Signup:
        return <OnboardingAuthSignup onSuccess={hideAuth} onLogin={onLogin} />;
      case AuthStep.Forgot:
        return <OnboardingAuthForgot onSuccess={onLogin} onLogin={onLogin} />;
      default:
        return null;
    }
  }, [hideAuth, onForgot, onLogin, onSignup, step]);

  return (
    <>
      <DismissButton onDismiss={hideAuth} />
      {authStep}
    </>
  );
};

OnboardingAuth.displayName = 'OnboardingAuth';

export default OnboardingAuth;
